export var getLSValue = function getLSValue(store, value) {
  if (value === void 0) {
    value = "";
  }

  if (localStorage.getItem("" + store)) {
    return JSON.parse(localStorage.getItem("" + store))[value];
  } else {
    return undefined;
  }
};
